import { render } from "./InvitationPolite.vue?vue&type=template&id=07bd8a42&scoped=true"
import script from "./InvitationPolite.vue?vue&type=script&lang=js"
export * from "./InvitationPolite.vue?vue&type=script&lang=js"

import "./InvitationPolite.vue?vue&type=style&index=0&id=07bd8a42&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07bd8a42"]])

export default __exports__